import { sendPost } from './common';

export function getCounselLinkParam(params: { counsel_id: number }) {
	return sendPost<string>('/api/get_counsel_detail_link_param/', params);
}
